// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"31731f48","264":"84c8e8b8","453":"94753de5","480":"1b2b457b","638":"7afb58f3","738":"00059da2"}[chunkId] + ".chunk.js";
};